<script>
  import { onMount } from "svelte";
  let { children, showNav = true } = $props();
  let container;

  const buttonClass = `
    tw:flex
    tw:size-6
    tw:items-center
    tw:justify-center
    tw:rounded-full
    tw:bg-zinc-200
    tw:text-zinc-700
    tw:transition-all
    tw:outline-primary
    tw:hover:scale-105
    tw:disabled:pointer-events-none
    tw:disabled:bg-transparent
    tw:disabled:ring-2
    tw:disabled:ring-inset
    tw:disabled:ring-zinc-200
    tw:disabled:text-zinc-200
  `;

  let showLeftMask = $state(false);
  let isAtStart = $state(true);
  let isAtEnd = $state(false);
  let clientWidth = $state(0);
  let cardWidth = $state(0);

  $effect(() => {
    let _ = clientWidth;
    handleScroll();
  });

  // Create a dynamic mask image based on scroll position
  let maskImage = $derived(
    `linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 1) ${!isAtStart ? "3%" : "0%"}, rgba(0, 0, 0, 1) ${!isAtEnd ? "97%" : "100%"}, transparent 100%)`,
  );

  function handleScroll() {
    if (container) {
      cardWidth = container.firstElementChild
        ? container.firstElementChild.offsetWidth
        : 0;

      // Show left mask only if scrolled to the right
      showLeftMask = container.scrollLeft > 0;
      // Detect if the container is scrolled to either end.
      isAtStart = container.scrollLeft === 0;
      isAtEnd =
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth - 1;
    }
  }

  onMount(() => {
    // Set initial scroll position
    container.scrollLeft = 0;
    handleScroll();
  });
</script>

{#if showNav}
  <nav class="tw:absolute tw:top-3 tw:right-3 tw:flex tw:gap-1">
    <button
      aria-label="Scroll left"
      type="button"
      class={buttonClass}
      disabled={isAtStart}
      onclick={() =>
        container.scrollBy({
          left: -cardWidth,
          behavior: "smooth",
        })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      >
        <path
          d="M14.125 8.14a20.357 20.357 0 0 0-3.894 3.701.472.472 0 0 0 0 .596 20.359 20.359 0 0 0 3.894 3.702"
        />
      </svg>
    </button>
    <button
      aria-label="Scroll right"
      type="button"
      class={buttonClass}
      disabled={isAtEnd}
      onclick={() =>
        container.scrollBy({
          left: cardWidth,
          behavior: "smooth",
        })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      >
        <path
          d="M10 8.14a20.351 20.351 0 0 1 3.894 3.701.472.472 0 0 1 0 .596A20.353 20.353 0 0 1 10 16.139"
        />
      </svg>
    </button>
  </nav>
{/if}
<div
  bind:this={container}
  onscroll={handleScroll}
  bind:clientWidth
  class="tw:relative tw:isolate tw:no-scrollbar tw:flex tw:w-full tw:max-w-screen tw:grow tw:snap-x tw:items-center tw:gap-4 tw:overflow-clip tw:overflow-x-auto tw:px-0 tw:py-1 tw:pb-2 tw:*:transition-all"
  style="mask-image: {maskImage};"
>
  {@render children?.()}

  <!-- Spacer -->
  <div class="tw:-ml-3 tw:shrink-0"></div>
</div>
